'use client';

import React, { useState } from 'react';
import { Search, Bell, Zap } from 'lucide-react';

export default function TopBar() {
  const [searching, setSearching] = useState(false);

  return (
    <header
      className="h-14 border-b border-border flex items-center gap-4 px-6 shrink-0"
      style={{ background: '#0f0f1e' }}
    >
      {/* Search */}
      <div className="flex-1 max-w-sm">
        <div className="relative">
          <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2" style={{ color: '#7070a0' }} />
          <input
            type="text"
            placeholder="Search scripts, trends, reels..."
            onFocus={() => setSearching(true)}
            onBlur={() => setSearching(false)}
            className="w-full pl-8 pr-3 py-1.5 border rounded-md text-sm text-foreground placeholder:text-muted-foreground focus:outline-none transition-all"
            style={{
              background: '#1a1a2e',
              borderColor: searching ? '#c13584' : '#2a2a42',
              boxShadow: searching ? '0 0 0 1px #c1358440' : 'none',
            }}
          />
          <span className="absolute right-2 top-1/2 -translate-y-1/2 text-2xs font-mono px-1 rounded hidden sm:block" style={{ color: '#7070a0', background: '#1e1e30' }}>
            ⌘K
          </span>
        </div>
      </div>

      <div className="flex items-center gap-2 ml-auto">
        {/* Pipeline Run Status */}
        <div className="hidden md:flex items-center gap-2 px-3 py-1.5 border rounded-md" style={{ background: '#1a1a2e', borderColor: '#2a2a42' }}>
          <span className="w-1.5 h-1.5 rounded-full bg-positive pulse-green" />
          <span className="text-xs font-mono" style={{ color: '#7070a0' }}>Last run: 9:30 IST</span>
        </div>

        {/* Force Run */}
        <button
          className="flex items-center gap-1.5 px-3 py-1.5 rounded-md text-xs font-semibold text-white transition-all duration-150 active:scale-95"
          style={{
            background: 'linear-gradient(135deg, #833ab4, #c13584, #f77737)',
            boxShadow: '0 2px 12px #c1358440',
          }}
        >
          <Zap size={13} />
          <span className="hidden sm:block">Force Run</span>
        </button>

        {/* Notifications */}
        <button
          className="relative p-2 rounded-md transition-all duration-150"
          style={{ color: '#7070a0' }}
          onMouseEnter={(e) => {
            (e.currentTarget as HTMLElement).style.background = '#1e1e30';
            (e.currentTarget as HTMLElement).style.color = '#fafafa';
          }}
          onMouseLeave={(e) => {
            (e.currentTarget as HTMLElement).style.background = '';
            (e.currentTarget as HTMLElement).style.color = '#7070a0';
          }}
        >
          <Bell size={16} />
          <span className="absolute top-1 right-1 w-2 h-2 rounded-full bg-negative" />
        </button>

        {/* Avatar with Instagram gradient border */}
        <div
          className="w-8 h-8 rounded-full flex items-center justify-center text-xs font-semibold text-white"
          style={{
            background: 'linear-gradient(#12121e, #12121e) padding-box, linear-gradient(135deg, #833ab4, #c13584, #f77737) border-box',
            border: '2px solid transparent',
          }}
        >
          OP
        </div>
      </div>
    </header>
  );
}